module.exports = __webpack_public_path__ + "static/media/Solve.d02085ab.svg";